<template>
    <p :class="[pClass, { invalid: isInvalid }]">
        <input type="radio"
               :id="id"
               :name="name"
               :value="id"
               v-model="inputVal"
               @change="onChange"
               :disabled="disabled"
        >
        <label :for="id">
            <slot></slot>
        </label>
    </p>
</template>

<script>
	export default {
		name: "RadioInput",
		props: {
			id: [String, Number, Boolean],
			name: String,
			val: [String, Number, Boolean, Array],
			value: [String, Number, Boolean, Array],
			pClass: {
				type: String,
				default: 'field'
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		data: function () {
			return {
				forcedInvalid: false,
				invalidText: null,
        inputVal: this.val
			}
		},
		computed: {
			isInvalid() {
				return (this.required && !this.value) || this.isForcedInvalid
			},
			isForcedInvalid() {
				return this.forcedInvalid
			}
		},
		methods: {
			onChange: function (e) {
				this.$emit('input', this.id)
			},
            setForcedInvalid(value = false, invalidText = null) {
				this.forcedInvalid = value
				this.invalidText = value === false ? null : invalidText
			}
		},
    watch: {
      val: function(val){
        this.inputVal = val;
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/common/RadioInput.vue